import {useContext} from 'react';
import { SessionContext } from "../../context/session";

export default function useSessionData() {
	const [ session, setSession ] = useContext(SessionContext);

	return [ session, setSession ];
}